<template>
    <div>
        <table class="table w-full">
            <tr>
                <th class="text-left">Event Name</th>
                <th class="text-center">Alarm</th>
                <th class="text-center">Event Code</th>
                <th class="text-right">Action</th>
            </tr>

            <tr class="tr-select">
                <td class="text-left">
                    <v-select :loading="loadingEventLists" label="eventName" style="min-width:280px" v-model="event"
                        :options="eventLists"></v-select>
                </td>
                <td class="text-left">
                    <v-select style="width:145px" v-model="alarm" :options="alarmLists"></v-select>
                </td>
                <td class="text-left">
                    {{ generatedCode }}
                </td>
                <td class="text-left">
                    <a @click.prevent="addToLists" href="javascript:void(0)"><feather-icon icon="PlusIcon" /></a>
                </td>
            </tr>
            <tr v-for="(ev, i) in selectedEvents" :key="i" :class="i == 0 ? 'tr-first-list' : ''">
                <td>
                    {{ ev.analyticEventName }}
                </td>
                <td v-if="selectedEvent != null && selectedEvent.id == ev.id">
                    <v-select style="width:145px" v-model="alarmEdit" :options="alarmLists"></v-select>
                </td>
                <td v-else>
                    {{ ev.alarmOn == 1 ? "Enable" : "Disable" }}
                </td>
                <td>
                    {{ ev.eventCode }}
                </td>
                <td>
                    <div class="flex items-center">
                        <a @click.prevent="copyCode(generateEventCode(ev.event.code))" class="mr-1"
                            href="javascript:void(0)"><feather-icon icon="CopyIcon" /></a>
                        <span v-if="selectedEvent != null && selectedEvent.id == ev.id" @click.prevent="editData(ev)" class="mr-1"><feather-icon icon="PencilIcon" /></span>
                        <a v-else @click.prevent="editData(ev)" class="mr-1"
                            href="javascript:void(0)"><feather-icon icon="EditIcon" /></a>
                        <a @click.prevent="removeData(ev.id)" href="javascript:void(0)"><feather-icon
                                icon="TrashIcon" /></a>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import api from "@/api";
import vSelect from "vue-select";

export default {
    props: ["areaBind", "cameraName", "name"],
    data() {
        return {
            selectedEvent: null,
            selectedEvents: [],
            event: {},
            alarm: {
                code: 1,
                label: "Enable"
            },
            alarmEdit: {
                code: 1,
                label: "Enable"
            },
            eventLists: [],
            alarmLists: [
                {
                    code: 0,
                    label: "Disable"
                },
                {
                    code: 1,
                    label: "Enable"
                }
            ],
            loadingEventLists: false
        }
    },
    components: { vSelect },
    computed: {
        generatedCode() {
            return `[IS][${this.event.eventCode}][${this.areaBind}][${this.name}]`
        },
        camera() {
            return this.$store.state.currentCamera
        },
    },
    watch: {
        alarmEdit: function(newVal, oldVal) {
            if(newVal != null && newVal != '') {
                if(newVal != oldVal) {
                    this.updateCustomEvent()
                }
            } 
        }
    },
    created() {
        this.getEventLists()
        this.getSelectedtCameraEventLists()
    },
    methods: {
        getSelectedtCameraEventLists() {
            this.$vs.loading()
            api.getSelectedtCameraEventLists({ cameraId: this.camera.id })
                .then(result => result.data)
                .then(data => {
                    if (data.status) {
                        this.selectedEvents = data.data
                    }
                    this.$vs.loading.close()
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
        },
        addToLists() {
            this.$vs.loading()
            api.saveOtherCameraEvent({
                "cameraId": this.camera.id,
                "analyticEventName": this.event.eventName,
                "parameterEventId": this.event.id,
                "alarmOn": this.alarm.code,
                "areaId": this.camera.areaId,
                "siteId": this.camera.siteId,
                "eventCode": this.generatedCode,
                "statusId": this.camera.statusId
            }).then(result => result.data)
                .then(data => {
                    this.$vs.loading.close()

                    if (data.status) {
                        this.$vs.notify({
                            title: 'Success',
                            text: 'Add more event success',
                            color: 'success',
                            position: 'bottom-center'
                        })
                        this.getSelectedtCameraEventLists()
                    } else {
                        this.$vs.notify({
                            title: 'Failed',
                            text: data.message,
                            color: 'danger',
                            position: 'bottom-center'
                        })
                    }
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
        },
        updateCustomEvent() {
            this.$vs.loading()
            api.updateOtherCameraEvent({
                "id": this.selectedEvent.id,
                "cameraId": this.selectedEvent.cameraId,
                "analyticEventName": this.selectedEvent.analyticEventName,
                "parameterEventId": this.selectedEvent.parameterEventId,
                "alarmOn": this.alarmEdit.code,
                "areaId": this.selectedEvent.areaId,
                "siteId": this.selectedEvent.siteId,
                "eventCode": this.selectedEvent.eventCode,
                "statusId": this.selectedEvent.statusId,
            }).then(result => result.data)
                .then(data => {
                    this.$vs.loading.close()

                    if (data.status) {
                        this.$vs.notify({
                            title: 'Success',
                            text: 'Update more event success',
                            color: 'success',
                            position: 'bottom-center'
                        })
                        this.getSelectedtCameraEventLists()
                    } else {
                        this.$vs.notify({
                            title: 'Failed',
                            text: data.message,
                            color: 'danger',
                            position: 'bottom-center'
                        })
                    }
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
        },
        generateEventCode(code) {
            return `[IS][${code}][${this.areaBind}][${this.name}]`
        },
        removeData(id) {
            this.$vs.loading()
            api.deleteOtherCameraEvent(id).then(result => result.data)
                .then(data => {
                    if (data.status) {
                        this.$vs.loading.close()
                        this.getSelectedtCameraEventLists()
                    }
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
        },
        copyCode(valName) {
            this.copyToClipboard(valName)

            this.$vs.notify({
                title: 'Success',
                text: 'Analytic Event Name has been copy to clipboard',
                color: 'success',
                position: 'bottom-center'
            })
        },
        copyToClipboard(text) {
            var dummy = document.createElement("textarea");
            // to avoid breaking orgain page when copying more words
            // cant copy when adding below this code
            // dummy.style.display = 'none'
            document.body.appendChild(dummy);
            //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
            dummy.value = text;
            dummy.select();
            document.execCommand("copy");
            document.body.removeChild(dummy);
        },
        getEventLists() {
            if (this.$store.state.events.length > 0) {
                this.eventLists = this.$store.state.events
                this.event = this.eventLists[0]
            } else {
                this.loadingEventLists = true
                api.getEventLists()
                    .then(result => result.data)
                    .then(data => {
                        if (data.status) {
                            this.eventLists = data.data
                            this.event = this.eventLists[0]

                            this.$store.dispatch('updateEventLists', data.data)
                        }
                        this.loadingEventLists = false
                    })
                    .catch((e) => {
                        console.log(e)
                        this.loadingEventLists = false
                    });
            }
        },
        editData(ev) {
            this.selectedEvent = ev
        }
    }
}
</script>

<style scoped>
.table td {
    padding-right: 20px;
}

.table .tr-select td {
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
}

.table .tr-first-list td {
    padding-top: 20px;
}
</style>